import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useWorkspace } from '../hooks/useWorkspace';
import WorkspaceSelector from './WorkspaceSelector';
import { Logo } from './Logo';
import CreateWorkspaceModal from './CreateWorkspaceModal';
import SEOHead from './SEOHead';

const navigation = [
  { name: 'Dashboard', href: '/dashboard' },
  { name: 'Settings', href: '/settings/account' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { showCreateModal, modalExistingWorkspaceId, openCreateModal, closeCreateModal, refreshWorkspaces } = useWorkspace();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead noIndex title="Dashboard" description="" />
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo and Workspace Selector */}
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex items-center">
                <Logo className="h-8 w-auto" />
              </Link>

              {/* Divider */}
              <div className="h-6 w-px bg-gray-200" />

              {/* Workspace Selector */}
              <WorkspaceSelector onCreateNew={() => openCreateModal()} />
            </div>

            {/* Navigation */}
            <nav className="flex space-x-8">
              {navigation.map((item) => {
                const isActive = item.name === 'Settings'
                  ? location.pathname.startsWith('/settings')
                  : location.pathname === item.href;

                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 ${
                      isActive
                        ? 'border-primary-500 text-gray-900'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </nav>

            {/* User menu */}
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-500">
                {user?.name || user?.email}
              </span>
              <button
                onClick={logout}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      {/* Create Workspace Modal — single instance for the whole app */}
      <CreateWorkspaceModal
        isOpen={showCreateModal}
        onClose={closeCreateModal}
        onSuccess={() => refreshWorkspaces()}
        existingWorkspaceId={modalExistingWorkspaceId}
      />
    </div>
  );
}
